var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-progress",attrs:{"id":"container-progress"}},[_c('canvas',{style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }